import { useEffect, useState } from "react";
import { putArchiveData, postArchiveData, getArchiveDataWithId } from "./api";
import { Loading } from "components/Loading/loading";
import { Textbox } from "components/Textbox/Textbox";
import { Button } from "components/Button/Button";
import { ModalForm } from "components/ModalForm/ModalForm";
import { ArchiveAccess } from "./ArchiveAccess";
import { trans } from "utils/helpers";
import { Toast } from "components/ToastShow/ToastAlert";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { MessageType } from "types/enum";

interface props {
    showForm: (e:boolean) => void
    selectedObj: any
    mode: any

}


export const ArchiveForm = ({showForm, selectedObj, mode}: props) => {
    const [response, setResponse] = useState<Response | any>(null);
    const [resetForm, setResetForm] = useState(false);
    const [EditForm, setEditForm] = useState<any | null>(null);
    const [loading, setLoading] = useState(false);
    const [showAccess, setShowAccess] = useState<any>(false);
    const [boardData, setBoardData] = useState<any>(false);
    const [userChanges, setUserChanges] = useState({});



    const handleSubmit = async(e) => {
        e.preventDefault()        
     if(mode == "create"){
    const data = {
        Title: e.target.Title.value,
    }
        setBoardData(data)
        setShowAccess(true)
    }else{
    const data = {
        Id: selectedObj.Id,
        Title: e.target.Title.value, 
        ActivityStatus: parseInt(e.target.ActivityStatus.value),
    }
  
    try {
        const res = await putArchiveData(data)
        getArchiveDataAsync(); 
        setResetForm(true); 
        sessionStorage.setItem("changingforms" , "false");
        setUserChanges({});
        setEditForm(null) 
        showForm(true)
        } catch (error) {    }

    } 
}




async function accessDatahandler(data) {
    if(mode == "create"){
        let formdata:any ={}
        formdata.organizationalArchive = boardData
        formdata.OrganizationalArchiveAccesses = data ;
        try {
            const res = await postArchiveData(formdata)
            getArchiveDataAsync(); 
            setResetForm(true);
            showForm(true)
        } catch (error) {

        }
    }
}

function cancel() {
    if(sessionStorage.getItem("changingforms")+""=="true"){
        // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{
        //     sessionStorage.setItem("changingforms" , "false");
        //     setUserChanges({});
        //     showForm(false)
        // });
        Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{
            sessionStorage.setItem("changingforms" , "false");
            setUserChanges({});
            showForm(false)
        });
    }else{
        showForm(false)     
    };


}

    async function getArchiveDataAsync() {
        setLoading(false)
        try {
           const res = await getArchiveDataWithId(selectedObj.Id);
           setEditForm(res.Data);
      
        } catch (error) {
        }
        setLoading(true)
    }
    

    const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = '';
      };


    useEffect(() => {
        if(Object.values(userChanges).filter((item)=>item!=null).length>0){

            sessionStorage.setItem("changingforms" , "true")
              window.addEventListener('beforeunload', handleBeforeUnload);
              return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
              };
        }else{
            sessionStorage.setItem("changingforms" , "false")
            window.removeEventListener('beforeunload', handleBeforeUnload);

        }
    }, [userChanges]);

    useEffect(() => {
        if (resetForm) setResetForm(false);
    }, [resetForm]);


    useEffect(() => {
        if(selectedObj?.Id && mode !="create"){
            getArchiveDataAsync()
        }else{
            setLoading(true)
        }
    }, [selectedObj]);

    return (
        <>
            { showAccess &&
              <ModalForm mode={mode}modalProfileKey={"Users"} title={trans("Users")} onHide={() => setShowAccess(false)} show={showAccess}>
                  <ArchiveAccess
                    archive={selectedObj} 
                    showForm={setShowAccess} 
                    accessDatahandler={accessDatahandler} 
                    accessData={[]}
                    mode={mode}
                  />
              </ModalForm>
            }
            <div className="card">
                <div className="">
                    {loading ?
                        <form className="TypeSettingForm row card-body " onSubmit={handleSubmit}>
                            <div className="col-md-4 col-sm-12">
                                <Textbox
                                    Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                     required={true} 
                                     textboxName={"Title"}
                                     textboxType="text" 
                                     resetForm={resetForm}
                                     labelText={"Title"} 
                                     mode={mode === "view" ? "view" : null}
                                     defaultValue={EditForm?.Title} 
                                 />
                            </div>
                            {mode != "create" && 
                             <div className="col-md-4 col-sm-12">
                                <EnumerationTypeSelect
                                    Change={(e)=>{setUserChanges({...userChanges , ...e})}} 
                                    name="ActivityStatus"
                                    label="ActivityStatus"
                                    enumTypeSelect="ActivityStatus"
                                    value={EditForm?.ActivityStatus}
                                    mode={mode === "view" ? "view" : null}
                                />
                             </div>
                            }
                            {mode !== 'view' ?
                                 <div className="d-flex justify-content-end my-2">
                                     <Button value="submit" btnType="submit"  />
                                     <Button value="cancel" btnType="cancel" onClick={() => cancel()}  />
                                 </div>
                                 :
                                 <div className="col-lg-12 mt-1 btns_form">
                                 <Button btnType="primary" value="close" onClick={()=>{cancel()}} />
                                 </div>
                            }
                        </form>
                        : <Loading />
                    }
                </div>
            </div>
        </>
    );
}